module["exports"] = ["+351 2########", "+351 3########", "+351 91#######", "+351 92#######", "+351 93#######", "+351 96#######"];